import { DataCard } from "components/common/DataCard";
import { RepaymentDetails } from "components/common/RepaymentDetails";
import {
  ExistingLoanDetails,
  RepaymentOption,
} from "domain/indicativeRepaymentOptions";
import { EXTEND_BY_DC_HEADING } from "./ExtendTerm.const";

type ExtendTermByProps = {
  repaymentOption: RepaymentOption;
  existingLoanDetails: ExistingLoanDetails;
};

export const ExtendTermBy = ({
  repaymentOption,
  existingLoanDetails,
}: ExtendTermByProps) => (
  <>
    <DataCard header={EXTEND_BY_DC_HEADING}>
      <RepaymentDetails
        existingLoanDetails={existingLoanDetails}
        repaymentOption={repaymentOption}
      />
    </DataCard>
  </>
);
